import Cert2CheckItems from "./Cert2CheckItems";

const getCert2CheckItem = (idx) => {
    console.log('getCert2CheckItem : ' + idx);
  if (8 > idx)
    return Cert2CheckItems[idx];
  else {
    for (var i=7; i < Cert2CheckItems.length; i++) {
      var item = Cert2CheckItems[i];
      console.log(item);
      if (item.idx == idx) {
        return item;
      }
    }
  }
  return null;
};

const CertificationInfo2ConfirmV2 = ({fields, certifiedEra, cert2Checks, viewMode, member}) => {
/*
  const acquiredItems = [
      '日本スポーツ協会',
      '日本整形外科学会',
      '日本医師会',
      '日本障がい者スポーツ協会',
      'なし'
  ];


  const acquiredItems = [
      '理学療法士',
      '看護師',
      '日本体育協会アスレチックトレーナー',
      '薬剤師',
      'JADA　公認スポーツファーマシスト',
      '健康運動指導士',
      '柔道整復師',
      '鍼灸師',
      '臨床検査技師',
      '管理栄養士',
      '研究・教育機関のスタッフ',
      '大学院生・大学院修了者',
      'その他'
  ];
*/
  const getCertifiedItems = () => {
      console.log('getCertifiedItems...');
      console.log(cert2Checks);
    if (!cert2Checks) return;
    let arr = [];
    for (let i = 0; i < cert2Checks.length; i++) {
	if (0 != cert2Checks[i]) arr.push(getCert2CheckItem(i).label + (i === 11 ? '' : ' (認定資格番号: ' + (viewMode ? member['certifiedNo'+i] : fields['certifiedNo'+i]) + ', 取得年月日: ' + (viewMode ? member['certifiedDate'+i] : fields['certifiedDate'+i]) + ')'));
    }
    return arr//.join("\n");
  };
    
  return (
    <>
              <h3>資格</h3>
              <dl>
                <dt className="hiddenRow">取得資格番号<span className="red">*</span></dt>
                <dd className="hiddenRow">{viewMode ? member.certificationNumber : fields.certificationNumber}&nbsp;</dd>
                <dt className="hiddenRow">取得年月日<span className="red">*</span></dt>
          <dd className="hiddenRow"> {viewMode ? member.acquiredDate : fields.acquiredDate}&nbsp;</dd>
                
                <dt>資格・身分<span className="red">*</span></dt>
          <dd> { getCertifiedItems().map((h) => (<p className="newLine">{h}</p>)) }&nbsp;</dd>
              </dl>
              <h3 className="">学位</h3>
              <dl className="">
                <dt>学位<span className="red">*</span></dt>
                <dd>{ viewMode ? member.degree  :  fields.degree }&nbsp;</dd>
              </dl>
    </>
  );
}

export default CertificationInfo2ConfirmV2;
